import { render, staticRenderFns } from "./payslip-header.vue?vue&type=template&id=4e4a141b&scoped=true&"
import script from "./payslip-header.vue?vue&type=script&lang=js&"
export * from "./payslip-header.vue?vue&type=script&lang=js&"
import style0 from "./payslip-header.vue?vue&type=style&index=0&id=4e4a141b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4a141b",
  null
  
)

export default component.exports